"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Custom_1 = __importDefault(require("../decorators/Custom"));
const ProductSubscriptionCreateResource_1 = __importDefault(require("../ProductSubscribed/ProductSubscriptionCreateResource"));
const Resource_1 = __importDefault(require("../Resource"));
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const ESubscriptionType_1 = require("../../enums/Subscription/ESubscriptionType");
class SubscriptionCreateRequestResource extends Resource_1.default {
}
exports.default = SubscriptionCreateRequestResource;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => ProductSubscriptionCreateResource_1.default),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, Custom_1.default)((products) => [...new Set(products.map((product) => product.subscriberId))].length === 1, {
        message: ValidationErrors_1.EValidationError.subscriberNotSame,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SubscriptionCreateRequestResource.prototype, "productsSubscribed", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(ESubscriptionType_1.ESubscriptionType),
    __metadata("design:type", String)
], SubscriptionCreateRequestResource.prototype, "subscriptionType", void 0);
